import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const MegaMenuItemThirdLevel = ({
  title = '',
  url = '',
  obfuscate = false,
  obfuscateDataUrl,
  count = null,
  attributes,
  classStyle,
  disableForLanguage = false,
}) => {

  const renderLink = () => {

    const classFromBO = attributes?.class || '';
    const targetFromBO = attributes?.target || '';

    const label = (
      <>
        {title} {count && ` (${count})`}
      </>
    );

    if (obfuscate) {
      return (
        <span
          className={cn('obfuscate', classFromBO)}
          role="link"
          tabIndex="0"
          data-link={obfuscateDataUrl}
          data-target={targetFromBO}
        >
          {label}
        </span>
      );
    }

    return (
      <a
        href={url}
        className={cn(classFromBO)}
        data-target={targetFromBO}
      >
        {label}
      </a>
    );
  };

  if (disableForLanguage) return null;

  return (
    <div className={cn('megamenu__item megamenu__item_third-level', classStyle)}>
      {renderLink()}
    </div>
  );
};

MegaMenuItemThirdLevel.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
  obfuscate: PropTypes.bool,
  obfuscateDataUrl: PropTypes.string,
  count: PropTypes.number,
  attributes: PropTypes.object,
  classStyle: PropTypes.string,
  disableForLanguage: PropTypes.bool,
};

export default React.memo(MegaMenuItemThirdLevel);
